import {
  TabSectionType,
  WorkspaceTab,
  WorkspaceTabSection,
} from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { ConceptSections } from '../../../../../shared/enums';
import { AWFSection } from '@ansys-internal/awf-angular/core';
import { IconType } from '@ansys-internal/awc-angular/icons';

@AWFSection({
  path: ConceptSections.COMPONENT,
})
export class ComponentSection implements TabSectionType {
  public type: ConceptSections = ConceptSections.COMPONENT;
  public title: string = 'Component';
  public icon: IconType = { icon: Icons.MODELER };

  async getTitle(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<string> {
    return this.title;
  }

  async getIcon(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<IconType> {
    return this.icon;
  }
}
